export default "__VITE_ASSET__b3b06bf5__"